// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { ShareOptions, UpdateWishListApiParameter } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setManageShareListModalIsOpen from "@insite/client-framework/Store/Components/ManageShareListModal/Handlers/SetManageShareListModalIsOpen";
import sendWishListCopy from "@insite/client-framework/Store/Components/ShareListModal/Handlers/SendWishListCopy";
import setShareListModalIsOpen from "@insite/client-framework/Store/Components/ShareListModal/Handlers/SetShareListModalIsOpen";
import updateWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/UpdateWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Radio, { RadioProps, RadioStyle } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

// Starter Custom Code - >
import getColor from "@insite/mobius/utilities/getColor";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import FormWrapper from "@store/Library/Components/Toolkit/FormWrapper";
import { formGridProps } from "@store/Themes/common/props/form";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Starter Custom Code

interface OwnProps {
    extendedStyles?: ShareListModalStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    modalIsOpen: state.components.shareListModal.isOpen,
    wishList: getWishListState(state, state.components.shareListModal.wishListId).value,
    fromManage: state.components.shareListModal.fromManage,
});

const mapDispatchToProps = {
    setShareListModalIsOpen,
    setManageShareListModalIsOpen,
    updateWishList: makeHandlerChainAwaitable(updateWishList),
    sendWishListCopy: makeHandlerChainAwaitable(sendWishListCopy),
};

export interface ShareListModalStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    shareListOptionGridItem?: GridItemProps;
    shareListOptionText?: TypographyPresentationProps;
    shareListOptionRadioGroup?: RadioGroupProps;
    sendCopyRadio?: RadioProps;
    shareListRadio?: RadioProps;
    shareListTooltip?: TooltipPresentationProps;
    shareByOptionGridItem?: GridItemProps;
    shareByOptionText?: TypographyPresentationProps;
    shareByOptionRadioGroup?: RadioGroupProps;
    shareByEmailRadio?: RadioProps;
    shareByEmailTooltip?: TooltipPresentationProps;
    shareByBillingRadio?: RadioProps;
    shareByBillingTooltip?: TooltipPresentationProps;
    shareByShippingTooltip?: TooltipPresentationProps;
    sendEmailNotificationGridItem?: GridItemProps;
    sendEmailNotificationCheckbox?: CheckboxPresentationProps;
    yourNameGridItem?: GridItemProps;
    yourNameTextField?: TextFieldPresentationProps;
    recipientEmailAddressGridItem?: GridItemProps;
    recipientEmailAddressTextField?: TextFieldPresentationProps;
    recipientEmailTooltip?: TooltipPresentationProps;
    shareMessageGridItem?: GridItemProps;
    shareMessageTextArea?: TextAreaProps;
    inviteMessageGridItem?: GridItemProps;
    inviteMessageTextArea?: TextAreaProps;
    bottomRowGridItem?: GridItemProps;
    buttonsContainer?: GridContainerProps;
    allowEditingGridItem?: GridItemProps;
    allowEditingCheckbox?: CheckboxPresentationProps;
    cancelButtonGridItem?: GridItemProps;
    cancelButton?: ButtonPresentationProps;
    sendButtonGridItem?: GridItemProps;
    sendButton?: ButtonPresentationProps;
}

export const shareListModalStyles: ShareListModalStyles = {
    modal: {
        // Store Custom Code - increased size
        size: 800,
        cssOverrides: {
            modalBody: css`
                // bunzl custom code
                overflow: auto;
            `,
            modalTitle: css`
                padding: ${pxToRem(10)} ${pxToRem(20)};
            `,
            modalContent: css`
                padding: ${pxToRem(20)};
                // bunzl custom code - removed overflow visible
            `,
        },
    },
    container: formGridProps.gridContainer,
    shareListOptionGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    shareListOptionRadioGroup: {
        css: css`
            flex-direction: row;

            ${breakpoint("xs", "down")} {
                flex-direction: column;
            }

            & > ${RadioStyle} {
                margin-top: ${pxToRem(10)};
            }
        `,
    },
    sendCopyRadio: {
        css: css`
            ${breakpoint("md", "up")} {
                margin-left: 1.25rem;
            }
            & + & {
                margin-top: ${pxToRem(10)};
                margin-left: ${pxToRem(20)};

                ${breakpoint("xs", "down")} {
                    margin-left: 0;
                }
            }
            input {
                margin-left: 0;
            }
        `,
    },
    shareListRadio: {
        css: css`
            margin-left: 1.25rem;
            input {
                margin-left: 0;
            }
        `,
    },
    shareListTooltip: {
        cssOverrides: {
            tooltipWrapper: css`
                margin-left: ${pxToRem(5)};
            `,
            tooltipContainer: css`
                width: ${pxToRem(500)};
                margin-left: -${pxToRem(400)};
                &::after {
                    left: ${pxToRem(400)};
                }

                ${breakpoint("xs", "down")} {
                    width: ${pxToRem(290)};
                    margin-left: -${pxToRem(270)};

                    &::after {
                        left: ${pxToRem(270)};
                    }
                }
            `,
            tooltipBody: css`
                padding: ${pxToRem(5)};
            `,
        },
        typographyProps: {
            css: css`
                line-height: ${x => x.theme.design.typography.lineHeight.base};
            `,
        },
    },
    shareByOptionGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    shareByOptionRadioGroup: {
        css: css`
            flex-direction: row;
            & > ${RadioStyle} {
                margin-top: ${pxToRem(10)};
            }

            ${breakpoint("xs", "down")} {
                flex-direction: column;
            }
        `,
    },
    shareByEmailRadio: {
        css: css`
            ${breakpoint("md", "up")} {
                margin-left: 1.25rem;
            }
            & + & {
                margin-top: ${pxToRem(10)};
                margin-left: ${pxToRem(20)};

                ${breakpoint("xs", "down")} {
                    margin-left: 0;
                }
            }
            input {
                margin-left: 0;
            }
        `,
    },
    shareByEmailTooltip: {
        cssOverrides: {
            tooltipWrapper: css`
                margin-left: ${pxToRem(5)};
            `,
        },
    },
    shareByBillingRadio: {
        css: css`
            input {
                margin-left: 0;
            }
        `,
    },
    shareByShippingTooltip: {
        cssOverrides: {
            tooltipContainer: css`
                bottom: 130%;
                left: -450%;
                &::after {
                    content: "";
                    position: absolute;
                    top: 100%;
                    left: 91%;
                    margin-left: -6px;
                    border-width: 6px;
                    border-style: solid;
                    border-color: ${getColor("common.backgroundContrast")} transparent transparent transparent;
                }
            `,
        },
    },
    shareByBillingTooltip: {
        cssOverrides: {
            tooltipWrapper: css`
                margin-left: ${pxToRem(5)};
            `,
        },
    },
    sendEmailNotificationGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    yourNameGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            align-items: flex-start;
        `,
    },
    recipientEmailAddressGridItem: { width: [12, 6, 6, 6, 6] },
    recipientEmailTooltip: {
        cssOverrides: {
            tooltipWrapper: css`
                margin-left: ${pxToRem(5)};
            `,
            tooltipContainer: css`
                margin-left: -${pxToRem(150)};
                &::after {
                    left: ${pxToRem(150)};
                }
            `,
        },
        typographyProps: {
            css: css`
                font-weight: ${x => x.theme.design.typography.weight.base};
            `,
        },
    },
    shareMessageGridItem: { width: 12 },
    shareMessageTextArea: {
        cssOverrides: {
            inputSelect: css`
                // bunzl custom code - reduced height
                max-height: 4rem;
                resize: none;
            `,
        },
    },
    inviteMessageGridItem: { width: 12 },
    inviteMessageTextArea: {
        cssOverrides: {
            inputSelect: css`
                // bunzl custom code - reduced height
                max-height: 4rem;
                resize: none;
            `,
        },
    },
    bottomRowGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    buttonsContainer: formGridProps.gridContainer,
    allowEditingGridItem: { width: [12, 6, 8, 6, 6] },
    cancelButton: {
        variant: "secondary",
    },
    sendButton: {
        variant: "primary",
    },
};

const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const ShareListModal = ({
    session,
    modalIsOpen,
    wishList,
    fromManage,
    extendedStyles,
    setShareListModalIsOpen,
    setManageShareListModalIsOpen,
    updateWishList,
    sendWishListCopy,
}: Props) => {
    const yourNameFieldRequiredMessage = siteMessage("Lists_Your_Name_Required") as string;
    const recipientEmailFieldRequiredMessage = siteMessage("Lists_Recipient_Email_Address_Required") as string;
    const recipientEmailFieldInvalidMessage = siteMessage("AddressInfo_EmailAddress_Validation") as string;
    const defaultInviteMessage = translate("I'd like to invite you to my shared list of products.");
    const defaultShareMessage = translate("I'd like to share my list of products with you.");

    const toasterContext = useContext(ToasterContext);
    const [styles] = useState(() => mergeToNew(shareListModalStyles, extendedStyles));

    const [shareListOption, setShareListOption] = useState(fromManage ? "shareList" : "sendCopy");
    const [shareByOption, setShareByOption] = useState("shareByEmail");
    const [allowEditList, setAllowEditList] = useState(wishList?.allowEdit || false);
    const [sendEmailNotification, setSendEmailNotification] = useState(false);
    const [yourName, setYourName] = useState(`${session.firstName} ${session.lastName}`);
    const [yourNameError, setYourNameError] = useState("");
    const [recipientEmailAddress, setRecipientEmailAddress] = useState("");
    const [recipientEmailAddressError, setRecipientEmailAddressError] = useState("");
    const [inviteMessage, setInviteMessage] = useState(defaultInviteMessage);
    const [shareMessage, setShareMessage] = useState(defaultShareMessage);
    const [inProgress, setInProgress] = useState(false);

    const modalCloseHandler = () => {
        setShareListModalIsOpen({ modalIsOpen: false });
        if (fromManage) {
            setManageShareListModalIsOpen({ modalIsOpen: true, wishListId: wishList?.id });
        }
    };

    const shareListOptionChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShareListOption(event.currentTarget.value);
    };

    const shareByOptionChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShareByOption(event.currentTarget.value);
    };

    const yourNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setYourName(event.target.value);
        setYourNameError(event.target.value.trim() ? "" : yourNameFieldRequiredMessage);
    };

    const recipientEmailAddressChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRecipientEmailAddress(event.target.value);
        if (!event.target.value) {
            setRecipientEmailAddressError(recipientEmailFieldRequiredMessage);
        } else {
            const emails = event.target.value.split(",");
            if (emails.some(email => !emailRegexp.test(email.trim()))) {
                setRecipientEmailAddressError(recipientEmailFieldInvalidMessage);
            } else {
                setRecipientEmailAddressError("");
            }
        }
    };

    const inviteMessageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInviteMessage(event.target.value.length > 300 ? event.target.value.slice(0, 300) : event.target.value);
    };

    const shareMessageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setShareMessage(event.target.value.length > 300 ? event.target.value.slice(0, 300) : event.target.value);
    };

    const allowEditListChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setAllowEditList(value);
    };

    const sendEmailNotificationChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setSendEmailNotification(value);
    };

    const sendClickHandler = async () => {
        if (!wishList) {
            return;
        }

        if (shareListOption === "sendCopy" || shareByOption === "shareByEmail") {
            if (yourNameError || recipientEmailAddressError) {
                return;
            }
            if (!yourName.trim() || !recipientEmailAddress.trim()) {
                setYourNameError(yourName.trim() ? "" : yourNameFieldRequiredMessage);
                setRecipientEmailAddressError(recipientEmailAddress.trim() ? "" : recipientEmailFieldRequiredMessage);
                return;
            }
        }

        setInProgress(true);

        const properties = shareByOption === "shareByShipTo" ? { shareByShipTo: "true" } : { shareByShipTo: "false" };

        const shareOption =
            shareByOption === "shareByEmail" ? ShareOptions.IndividualUsers : ShareOptions.AllCustomerUsers;
        if (shareListOption === "sendCopy") {
            await sendWishListCopy({
                wishList: {
                    ...wishList,
                    senderName: yourName,
                    recipientEmailAddress,
                    message: shareMessage,
                },
            });
        } else {
            await updateWishList({
                apiParameter: {
                    wishList: {
                        ...wishList,
                        properties,
                        allowEdit: allowEditList,
                        sendEmail: shareByOption === "shareByEmail" || sendEmailNotification,
                        shareOption,
                        message: shareByOption === "shareByEmail" || sendEmailNotification ? inviteMessage : "",
                        senderName: shareByOption === "shareByEmail" ? yourName : "",
                        recipientEmailAddress: shareByOption === "shareByEmail" ? recipientEmailAddress : "",
                    },
                },
            });
        }

        setShareListModalIsOpen({ modalIsOpen: false });

        const message =
            shareByOption === "shareByShipTo"
                ? "Your list has been shared with all users on the shipping account."
                : shareListOption === "sendCopy"
                  ? "A copy of your list has been sent."
                  : shareByOption === "shareByEmail"
                    ? "Your invite to the shared list has been sent."
                    : sendEmailNotification
                      ? "A notification email has been sent."
                      : "Your list has been shared with all users on the billing account.";
        toasterContext.addToast({ body: translate(message), messageType: "success" });
    };
    // Store Custom Code - wrapped in useCallBack to use in a dependency array
    const resetFields = useCallback(() => {
        setShareListOption(fromManage ? "shareList" : "sendCopy");
        setShareByOption("shareByEmail");
        setAllowEditList(wishList?.allowEdit || false);
        setSendEmailNotification(false);
        setYourName(`${session.firstName} ${session.lastName}`);
        setYourNameError("");
        setRecipientEmailAddress("");
        setRecipientEmailAddressError("");
        setInviteMessage(defaultInviteMessage);
        setShareMessage(defaultShareMessage);
        setInProgress(false);
    }, [
        defaultInviteMessage,
        defaultShareMessage,
        fromManage,
        session.firstName,
        session.lastName,
        wishList?.allowEdit,
    ]);

    const afterCloseHandler = () => {
        resetFields();
    };
    // fixed dependency array to include resetFields
    useEffect(() => {
        resetFields();
    }, [resetFields, wishList]);

    if (!wishList) {
        return null;
    }

    return (
        <Modal
            {...styles.modal}
            headline={translate("Share List")}
            isOpen={modalIsOpen}
            handleClose={modalCloseHandler}
            onAfterClose={afterCloseHandler}
        >
            <FormWrapper /* Store Custom Code - FormWrapper */>
                <GridContainer {...styles.container} data-test-selector="shareListForm">
                    {!fromManage && (
                        <GridItem {...styles.shareListOptionGridItem}>
                            <Typography {...styles.shareListOptionText}>
                                {siteMessage("Lists_Send_Copy_Or_Allow_Others_Access_List")}
                            </Typography>
                            <RadioGroup
                                {...styles.shareListOptionRadioGroup}
                                value={shareListOption}
                                onChangeHandler={shareListOptionChangeHandler}
                                data-test-selector="shareListOption"
                            >
                                <Radio {...styles.sendCopyRadio} value="sendCopy" data-test-selector="sendCopy">
                                    {translate("Send a copy")}
                                </Radio>
                                <Radio {...styles.shareListRadio} value="shareList" data-test-selector="shareList">
                                    {translate("Allow others to view or edit this list")}
                                    <Tooltip
                                        {...styles.shareListTooltip}
                                        text={
                                            siteMessage(
                                                "Lists_Invite_Individuals_Or_Make_Available_To_All_Customer_Users_Tooltip",
                                            ) as string
                                        }
                                    />
                                </Radio>
                            </RadioGroup>
                        </GridItem>
                    )}
                    {!fromManage && shareListOption === "shareList" && (
                        <>
                            <GridItem {...styles.shareByOptionGridItem}>
                                <Typography {...styles.shareByOptionText}>{translate("Assign users")}</Typography>
                                <RadioGroup
                                    {...styles.shareByOptionRadioGroup}
                                    value={shareByOption}
                                    onChangeHandler={shareByOptionChangeHandler}
                                    data-test-selector="shareByOption"
                                >
                                    <Radio
                                        {...styles.shareByEmailRadio}
                                        value="shareByEmail"
                                        data-test-selector="shareByEmail"
                                    >
                                        {translate("By email address")}
                                        <Tooltip
                                            {...styles.shareByEmailTooltip}
                                            text={siteMessage("Lists_Share_List_With_Anyone_Via_Email") as string}
                                        />
                                    </Radio>
                                    <Radio
                                        {...styles.shareByBillingRadio}
                                        value="shareByBilling"
                                        data-test-selector="shareByBilling"
                                    >
                                        {translate("By current billing address")}

                                        <Tooltip
                                            {...styles.shareByBillingTooltip}
                                            text={
                                                siteMessage(
                                                    "Lists_Your_List_Will_Be_Available_To_All_Customer_Users",
                                                ) as string
                                            }
                                        />
                                    </Radio>
                                    <Radio
                                        {...styles.shareByBillingRadio}
                                        value="shareByShipTo"
                                        data-test-selector="shareByShipTo"
                                    >
                                        {translate("By current shipping address")}
                                        <Tooltip
                                            {...styles.shareByShippingTooltip}
                                            text={
                                                siteMessage(
                                                    "Lists_Your_List_Will_Be_Available_To_All_Customer_Users",
                                                ) as string
                                            }
                                        />
                                    </Radio>
                                </RadioGroup>
                            </GridItem>
                            {(shareByOption === "shareByBilling" || shareByOption === "shareByShipTo") && (
                                <GridItem {...styles.sendEmailNotificationGridItem}>
                                    <Checkbox
                                        {...styles.sendEmailNotificationCheckbox}
                                        checked={sendEmailNotification}
                                        onChange={sendEmailNotificationChangeHandler}
                                        data-test-selector="sendEmailNotification"
                                    >
                                        {translate("Send an email notification to users")}
                                    </Checkbox>
                                </GridItem>
                            )}
                        </>
                    )}
                    {(shareListOption === "sendCopy" ||
                        (shareListOption === "shareList" && shareByOption === "shareByEmail")) && (
                        <>
                            <GridItem {...styles.yourNameGridItem}>
                                <TextField
                                    {...styles.yourNameTextField}
                                    label={translate("Your Name")}
                                    value={yourName}
                                    error={yourNameError}
                                    onChange={yourNameChangeHandler}
                                    required
                                    data-test-selector="yourName"
                                />
                            </GridItem>
                            <GridItem {...styles.recipientEmailAddressGridItem}>
                                <TextField
                                    {...styles.recipientEmailAddressTextField}
                                    label={
                                        <>
                                            {translate("Recipient Email Address")}
                                            <Tooltip
                                                {...styles.recipientEmailTooltip}
                                                text={siteMessage("Lists_Use_Comma_As_Delimiter") as string}
                                            />
                                        </>
                                    }
                                    value={recipientEmailAddress}
                                    error={recipientEmailAddressError}
                                    onChange={recipientEmailAddressChangeHandler}
                                    required
                                    data-test-selector="recipientEmailAddress"
                                />
                            </GridItem>
                        </>
                    )}
                    {shareListOption === "sendCopy" && (
                        <GridItem {...styles.shareMessageGridItem}>
                            <TextArea
                                {...styles.shareMessageTextArea}
                                label={translate("Message")}
                                value={shareMessage}
                                onChange={shareMessageChangeHandler}
                                hint={`${300 - shareMessage.length} ${translate("characters left")}`}
                                data-test-selector="shareMessage"
                            />
                        </GridItem>
                    )}
                    {shareListOption === "shareList" && (shareByOption === "shareByEmail" || sendEmailNotification) && (
                        <GridItem {...styles.inviteMessageGridItem}>
                            <TextArea
                                {...styles.inviteMessageTextArea}
                                label={translate("Message")}
                                value={inviteMessage}
                                onChange={inviteMessageChangeHandler}
                                hint={`${300 - inviteMessage.length} ${translate("characters left")}`}
                                data-test-selector="inviteMessage"
                            />
                        </GridItem>
                    )}
                    <GridItem {...styles.bottomRowGridItem}>
                        <GridContainer {...styles.buttonsContainer}>
                            {!fromManage && shareListOption === "shareList" && (
                                <GridItem {...styles.allowEditingGridItem}>
                                    <Checkbox
                                        {...styles.allowEditingCheckbox}
                                        checked={allowEditList}
                                        onChange={allowEditListChangeHandler}
                                        data-test-selector="allowEditList"
                                    >
                                        {translate("Allow Editing")}
                                    </Checkbox>
                                </GridItem>
                            )}
                        </GridContainer>
                    </GridItem>
                </GridContainer>
                <FormActions /* Starter Custom Code */>
                    <Button
                        {...styles.sendButton}
                        onClick={sendClickHandler}
                        disabled={inProgress}
                        data-test-selector="sendButton"
                    >
                        {translate("Send")}
                    </Button>

                    <Button {...styles.cancelButton} onClick={modalCloseHandler}>
                        {translate("Cancel")}
                    </Button>
                </FormActions>
            </FormWrapper>
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareListModal);
